export default "__VITE_ASSET__2vUe9J4b__"